import React, { useState } from 'react';
import { GET_QUOTES_INFORMATION_getQuotesInformation } from './graphql/__generated__/GET_QUOTES_INFORMATION';
import styled from 'styled-components';
import PolicyInformation from './PolicyInformation';
import QuoteOperations from './QuoteOperations';
import { Box } from 'grommet';
import AlertLoader from '../../components/gpaCancelPolicy/AlertLoader';
import { GET_QUOTE_DOCUMENTS_getQuotesInformation_documentsList } from './graphql/__generated__/GET_QUOTE_DOCUMENTS';
import DocumentsTable from './DocumentsTable';

const StyledLobName = styled.span`
  font-size: 1.5rem;
`;

const StyledUserName = styled.span`
  font-size: 1.2rem;
`;

export interface QuotesInformationProps {
  result: GET_QUOTES_INFORMATION_getQuotesInformation;
  redirectOnQuoteClickAction: Function;
  sourceSystemCode: string;
  withdrawClickHandler: Function;
  buttonDisabled: boolean;
  filteredAgentDocuments:
    | (GET_QUOTE_DOCUMENTS_getQuotesInformation_documentsList | null)[]
    | null;
  filteredPolicyDocuments:
    | (GET_QUOTE_DOCUMENTS_getQuotesInformation_documentsList | null)[]
    | null;
  downloadDocument: Function;
  uploadToken: string;
  uploadDoc: Function;
  deleteQuoteDocument: Function;
  onDelete: Function;
}

export default ({
  result,
  redirectOnQuoteClickAction,
  sourceSystemCode,
  withdrawClickHandler,
  buttonDisabled,
  filteredAgentDocuments,
  filteredPolicyDocuments,
  downloadDocument,
  uploadToken,
  uploadDoc,
  deleteQuoteDocument,
  onDelete
}: QuotesInformationProps) => {
  const [loader, setLoader] = useState<boolean>(false);

  const PLView =
    result?.lineOfBusinessCode === 'PersonalAutoLine' ||
    result?.lineOfBusinessCode === 'HomeownersLine_HOE';

  const isDeleteAllowed = result?.accountHolder === 'Person';

  return (
    <>
      {loader && <AlertLoader message="Processing..." />}
      <Box data-test-id="displayName" pad={{ vertical: 'small' }}>
        <StyledLobName>
          {result?.lineOfBusinessName} - Quote ({result?.jobNumber})
        </StyledLobName>
        <StyledUserName>{result?.contactName}</StyledUserName>
      </Box>
      {!PLView && (
        <QuoteOperations
          jobNumber={result?.jobNumber}
          latestPeriod={result?.latestPeriod}
          status={result?.status}
          closeDate={result?.closeDate}
          policyIssued={result?.policyIssued}
          redirectOnQuoteClickAction={redirectOnQuoteClickAction}
          sourceSystemCode={sourceSystemCode}
          loader={loader}
          setLoader={setLoader}
          withdrawClickHandler={withdrawClickHandler}
          buttonDisabled={buttonDisabled}
        />
      )}
      <PolicyInformation
        jobNumber={result?.jobNumber}
        contactName={result?.contactName}
        latestPeriod={result?.latestPeriod}
        createTime={result?.createTime}
        status={result?.status}
      />
      <div style={{ marginTop: '20px' }} />
      <DocumentsTable
        downloadDocument={downloadDocument}
        quoteDocuments={filteredPolicyDocuments}
        title="Policy Documents"
        isUploadAvailable={false}
        uploadToken={uploadToken}
        uploadDoc={uploadDoc}
        sourceSystemCode={sourceSystemCode}
        quoteNo={result?.jobNumber}
        deleteQuoteDocument={deleteQuoteDocument}
        onDelete={onDelete}
        isDeleteAllowed={false}
      />
      <div style={{ marginTop: '20px' }} />
      <DocumentsTable
        downloadDocument={downloadDocument}
        quoteDocuments={filteredAgentDocuments}
        title="Uploaded Documents"
        isUploadAvailable={true}
        uploadToken={uploadToken}
        uploadDoc={uploadDoc}
        sourceSystemCode={sourceSystemCode}
        quoteNo={result?.jobNumber}
        deleteQuoteDocument={deleteQuoteDocument}
        onDelete={onDelete}
        isDeleteAllowed={isDeleteAllowed}
      />
    </>
  );
};
